var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_627)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_261_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01607 44.4096C14.2473 43.4249 21.5258 42.5971 28.8193 41.9793C32.0557 41.7102 35.3301 41.4211 38.5831 41.6156C42.024 41.8204 46.3121 42.2226 49.1356 44.4349C51.8705 46.5725 50.0376 49.7869 47.9388 51.639C44.3854 54.751 39.2291 55.7733 34.6224 54.9569C30.8136 54.2911 25.0531 51.6338 27.2349 46.8194C28.7477 43.5065 32.6448 41.0377 35.6452 39.2575C39.1338 37.1847 42.81 35.4858 46.073 33.0591C48.0562 31.5824 50.1416 29.7736 50.9506 27.3508C52.9455 21.4355 47.5212 16.4946 42.2544 15.0799C35.2295 13.2193 23.5877 15.598 21.3335 23.5992C19.0748 31.6149 29.6353 33.994 35.3953 34.3747C41.1553 34.7555 47.265 33.9475 53.1145 33.3123C58.964 32.6772 64.9465 31.9723 70.8675 31.3118C71.4288 31.2474 71.9902 31.1829 72.5427 31.1473C74.843 30.9697 74.4305 27.4439 72.1345 27.6071C61.3573 28.4179 50.6846 30.4939 39.8684 30.9133C36.2918 31.0462 21.8878 30.5991 25.0351 23.8368C26.7552 20.1609 31.5893 18.581 35.332 18.1673C39.0893 17.7581 43.7759 18.3145 46.3955 21.3967C47.5864 22.8064 48.0483 24.8772 47.5402 26.2701C46.6261 28.7238 43.696 30.4309 41.6174 31.7517C37.9147 34.1064 33.8505 35.8756 30.3127 38.4708C27.6114 40.4695 24.5279 43.1412 23.5643 46.4807C20.6481 56.6338 34.8344 59.8595 42.0409 58.2823C47.8644 57.0069 57.8741 50.4586 53.0346 43.3578C51.09 40.5148 47.2924 39.3466 44.0809 38.7065C40.5841 38.0102 36.9867 37.8996 33.4303 38.0702C25.9091 38.4441 18.3926 39.3726 10.9241 40.3001C9.49954 40.4784 8.05596 40.6667 6.62693 40.8595C4.34922 41.1706 4.7428 44.7063 7.03506 44.3997L7.01607 44.4096Z",
    fill: "#64201F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4597 29.4256L48.7015 30.3115L43.2443 34.4345C43.2443 34.4345 43.8639 34.388 55.7585 33.0514L56.4642 29.4112L56.4597 29.4256Z",
    fill: "url(#paint0_linear_261_627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0466 38.7125C41.8278 38.3145 39.7278 38.0479 37.8028 38.0407L31.6456 41.6954C31.6456 41.6954 36.0152 41.5219 42.4509 41.9841L44.0422 38.7269L44.0466 38.7125Z",
    fill: "url(#paint1_linear_261_627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.367 42.8822C22.7258 42.3187 23.5729 42.5161 26.1056 42.2044L31.2787 38.073C31.2787 38.073 26.3304 38.5743 20.1778 39.211L19.3715 42.8677L19.367 42.8822Z",
    fill: "url(#paint2_linear_261_627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.818 34.1043C34.522 34.3123 34.8869 34.472 37.0568 34.4597C39.2054 33.4291 41.2663 32.1661 43.2654 30.7417C43.1869 30.6859 39.5105 31.2465 33.6729 30.6522L32.818 34.1043Z",
    fill: "url(#paint3_linear_261_627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4568 23.2257C47.9883 25.3811 47.7138 26.6878 46.0632 28.3775C43.2263 31.283 39.2866 33.217 35.7406 35.114C31.8382 37.186 27.9056 39.7703 25.22 43.3231C22.3392 47.1479 22.6389 52.2831 26.5045 55.3534L27.5586 54.0494L28.7433 52.58C24.7892 49.435 27.8 45.2392 30.6859 42.7439C34.1982 39.7141 38.4187 37.8507 42.3663 35.4765C46.9775 32.7057 52.545 28.9486 51.0173 22.835",
    fill: "#64201F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_627",
    x1: 49.3717,
    y1: 31.0967,
    x2: 50.3087,
    y2: 32.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#471818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#621F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#64201F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_627",
    x1: 37.2545,
    y1: 39.2112,
    x2: 38.2129,
    y2: 40.6317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#471818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#621F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#64201F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_627",
    x1: 25.6789,
    y1: 41.0382,
    x2: 24.9,
    y2: 39.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#471818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#621F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#64201F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_261_627",
    x1: 38.161,
    y1: 32.5994,
    x2: 37.4652,
    y2: 31.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#471818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#621F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#64201F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.5858,
    height: 58.5858,
    fill: "white",
    transform: "translate(18.1145 -0.00708008) rotate(17.0988)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_261_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.2475,
    height: 43.9394,
    fill: "white",
    transform: "translate(15.9614 6.99243) rotate(17.0988)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageEnd);
export default __webpack_public_path__ + "static/media/page-end.d89ff2019eb6c26a9bf19377398423e1.svg";
export { ForwardRef as ReactComponent };